import EditDeleteIcons from './EditDeleteIcons';

export default EditDeleteIcons;